import { useErrors } from '@auth0/auth0-acul-react/mfa-country-codes';
import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import SvgChevronLeft from 'creative-ui/uikit/svg/chevron-left';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthErrorBanner } from '@/components/AuthErrorBanner/AuthErrorBanner';
import { useTrackErrors } from '@/hooks/useTrackErrors';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackClick, trackPageView } from '@/lib/tagging';

import CountryCodeList from './components/CountryCodeList';
import { useMfaCountryCodesManager } from './hooks/useMfaCountryCodesManager';

function MfaCountryCodesScreen() {
  const { t } = useTranslation('mfaCountryCodes');
  useTransactionLocale();

  const { texts, handleBackAction } = useMfaCountryCodesManager();

  useEffect(() => {
    trackPageView('mfa/sms/country');
  }, []);

  const handleBack = () => {
    trackClick('mfa/sms/country/back');
    handleBackAction();
  };

  const { errors } = useErrors();
  const { generalErrorMessages } = useTrackErrors(
    errors,
    'mfa/sms/country/error',
  );

  // SDK first, i18n fallback
  document.title = texts?.pageTitle || t('page.title');

  const title = texts?.title || t('header.title');
  const description = texts?.description || t('header.description');
  const backButtonText = t('footer.backButton');

  return (
    <BaseWrapper>
      <CtaContainer alignment="left" className="u-margin-b-l">
        <Cta type="ghost-inline" svgLeft={SvgChevronLeft} onClick={handleBack}>
          {backButtonText}
        </Cta>
      </CtaContainer>
      <h1 className="u-heading-2 u-textCenter u-margin-b-l">{title}</h1>
      <p className="u-textCenter u-margin-b-l">{description}</p>
      <AuthErrorBanner errors={generalErrorMessages} />
      <CountryCodeList />
    </BaseWrapper>
  );
}

export default MfaCountryCodesScreen;
